// 在控制器中先运行 dictService.get(【typename】) 缓存 dict中枚举值
class dictService {
  constructor(httpRequest, $q) {
    this.$q = $q
    this.dictData = {}
    this.httpRequest = httpRequest
  }

  get(typename) {
    const deferred = this.$q.defer()
    this.httpRequest.get_dictByType(typename).then((res) => {
      deferred.resolve(res)
      this.dictData[typename] = res.data.value
    })
    return deferred.promise
  }

  /**
   * 缓存数据字典到sessionStorage
   */
  getAndCache(typeArry) {
    const deferred = this.$q.defer()
    const cachedDictStr = sessionStorage.getItem('dictData')
    // 缓存的字典
    let cachedDict = {}
    // 该页面需要的字典  为了不返回全部字典导致每个页面字典值过大
    const toResolveDict = {}
    if (cachedDictStr) {
      cachedDict = JSON.parse(cachedDictStr)
    }
    const requestArr = []
    let typeStr
    // 检查请求的字典值是否都已缓存，缓存的添加到返回的对象 没有缓存的请求后台
    for (let i = 0; i < typeArry.length; i++) {
      typeStr = typeArry[i]
      if (!cachedDict[typeStr]) {
        requestArr.push(typeStr)
      } else {
        toResolveDict[typeStr] = cachedDict[typeStr]
      }
    }
    if (requestArr.length > 0) {
      this.httpRequest
        .get_dictByTypeArr(JSON.stringify(requestArr))
        .then((disctDataRes) => {
          Object.assign(cachedDict, disctDataRes.data.value)
          Object.assign(toResolveDict, disctDataRes.data.value)
          sessionStorage.setItem('dictData', JSON.stringify(cachedDict))
          deferred.resolve(toResolveDict)
        })
    } else {
      deferred.resolve(toResolveDict)
    }
    return deferred.promise
  }
}
dictService.$inject = ['httpRequest', '$q']
export default dictService



// WEBPACK FOOTER //
// ./src/common/services/dictService.js